import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Header from '@/components/header'
import Index from '@/pages/index.vue'
import About from '@/pages/about.vue'
import Later from '@/pages/later.vue'
import Work from '@/pages/work.vue'
import Dynamic from '@/pages/dynamic.vue'
import Join from '@/pages/join.vue'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'index',
		component: Index,
		/*meta: {keepAlive: true},
		 beforeRouteLeave (to, from, next) {
		    if (to.path === '/work') {
		      from.meta.keepAlive = true
		    } else {
		      from.meta.keepAlive = false
		     // this.$destroy()
		    }
		    next()
		  }, */
	}, {
		path: '/home',
		name: 'home',
		component: Home
	}, {
		path: '/about',
		name: 'about',
		component: About
	}, {
		path: '/later',
		name: 'later',
		component: Later
	}, {
		path: '/work',
		name: 'work',
		component: Work,
		meta: { auth: true },
	}, {
		path: '/dynamic',
		name: 'dynamic',
		component: Dynamic
	}, {
		path: '/join',
		name: 'join',
		component: Join
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js